/**
 * file : TournamentRelated/Detail.jsx
 * 설명 : 토너먼트 상세 화면
 */

import _img2 from "assets/images/_img2.jpg"
import btn_play from "assets/images/btn_play.png"

import BetHistory from "./Common/BetHistory"
import Winning from "./Common/Winning"
import RealRanking from "./Common/RealRanking"
import PrizeWinner from "./Common/PrizeWinner"

import { useEffect, useState } from "react";
import { Link, useParams } from 'react-router-dom';
import { Insert, Search } from "components/Common/ApiCall";
import { AxiosCall, Fnc, Swal, Url } from "common/globals";
import { Spinner, Tab } from "components/Common/Componentization";

export default function Detail() {
  // 전달 받은 데이터
  const { tournament_idx } = useParams();
  // 타이머
  const [ timer, setTimer ] = useState([]);
  // 데이터
  const [datas, setDatas] = useState();
  // 데이터 로딩
  const [dataLoading, setDataLoading] = useState(false);
  // 신청 이력 데이터
  const [requestDatas, setRequestDatas] = useState();
  // Tab 관련
  const titles = ['실시간 랭킹', '나의 베팅 내역'];
  const contents = [<RealRanking tournament_idx={tournament_idx} setDataLoading={setDataLoading} />, <BetHistory tournament_idx={tournament_idx} setDataLoading={setDataLoading} />];
  // 상태에 따라 클래스 지정
  const bgChoice = (target) => {
    switch (target) {
      case 'S':
        return 'bg7';
      case 'R':
        return 'bg2';
      case 'E':
        return 'bg6';
      default:
        return 'bg0';
    }
  }
  // 접속
  const Access = () => {
    setDataLoading(true)
    AxiosCall.get(`/tournament-access-link?tournament_idx=${tournament_idx}`)
    .then((result) => {
      window.open(result.data.link, '_blank');
    }).catch(err => {
      const response = err.response;
      Swal.SwalAlert('error', '오류', `<div>${response.data.message}</div>`);
    }).finally(() => {
      setDataLoading(false)
    })
  }
  // 조회
  useEffect(() => {
    Search('/get-tournament-request' , setRequestDatas);
    Search('/tournament-detail', setDatas, setDataLoading, { tournament_idx: tournament_idx })
  }, [tournament_idx])
  // 모집 또는 진행 중 일때만 타이머 호출
  useEffect(() => {
    datas && (datas.tournament_state === 'R' || datas.tournament_state === 'S') && Fnc.Timer([datas], setTimer, () => {
      window.location.reload();
    })
  }, [datas])

  return(
    <>
      <Spinner show={dataLoading} />
      <div className="container_sub">
        {
          !Fnc.Empty(datas) && !Fnc.Empty(requestDatas) && <>
            <div className="location">전체토너먼트 &nbsp; &gt; &nbsp; {datas.tournament_state_name} 토너먼트</div>
            <div className="view_box box_style1 min-height">
              <h2>
                <span className={bgChoice(datas.tournament_state)}>{datas.tournament_state_name}</span>{datas.tournament_name}
              </h2>
              <div className="inner_view_box">
                <div className={`${datas.tournament_state !== 'S' ? 'margin-right-none' : null} box`}>
                  <div className="inner_box">
                    <p><img src={Url.TournamentImgUrl + datas.image} alt={datas.image} /></p>
                    <div className="stit">
                      <h2>{`ID: ${datas.tournament_idx}`}</h2>
                      <h3>{datas.tournament_name}</h3>
                    </div>
                    <div className="down_btn">
                      <div className="time">
                        {Fnc.Empty(timer[datas.tournament_idx]) ? `토너먼트 ${datas.tournament_state_name}` : `토너먼트 ${datas.tournament_state_name}: ${timer[datas.tournament_idx]}`}
                      </div>
                    </div>
                  </div>
                  <div className="box_content">
                    <ul>
                      <li>
                        <p>기간</p>
                        <p>
                          {`
                            ${Fnc.FormatDate(datas.tournament_start, true)} ~ ${Fnc.FormatDate(datas.tournament_end, true)}
                            (${Fnc.D_day(datas.tournament_start, datas.tournament_end)})
                          `}
                        </p>
                      </li>
                      <li>
                        <p>참여인원</p>
                        <p>
                          {datas.max_user === 0 ? '무제한 ' : `${datas.max_user.toLocaleString()}`}{` / ${datas.total_user_cnt}명`}
                        </p>
                      </li>
                      <li>
                        <p>게임사</p>
                        <p>{datas.vendor_name}</p>
                      </li>
                      <li>
                        <p>게임타입</p>
                        <p>{datas.game_type}</p>
                      </li>
                      <li>
                        <p>게임명</p>
                        <p>{datas.game_name}</p>
                      </li>
                      <li>
                        <p>입상조건</p>
                        <p>{datas.people_string}</p>
                      </li>
                      <li>
                        <p>상금</p>
                        <p className="txt_mint"><span className="won"></span>{datas.conditions_victory_name}</p>
                      </li>
                      <li>
                        <p>참가비</p>
                        <p>
                          {
                            datas.entryfee === 0
                            ? '참가비 없음' 
                            : <><span className="won"></span>{datas.entryfee.toLocaleString()}</>
                          }
                        </p>
                      </li>
                    </ul>
                  </div>
                </div>
                {/* ===================================== 실시간 당청 현황 ===================================== */}
                {
                  datas.tournament_state === 'S' && <Winning img={Url.TournamentImgUrl + datas.image} tournament_game_name={datas.game_name} tournament_idx={datas.tournament_idx} />
                }
              </div>
              <div className="view_bbs">
                {/* ========================================== Tab ========================================== */}
                {datas.tournament_state === 'S' && <Tab title={titles} content={contents} style={`box_style1`} />}
                {/* ========================================= 입상자 ========================================= */}
                {datas.tournament_state === 'T' && <PrizeWinner tournament_idx={tournament_idx} setDataLoading={setDataLoading} />}
                {/* ======================================== 신청하기 ======================================== */}
                {
                  datas.tournament_state === 'R' && <div className="btns_wrap mt_50 mb_50">
                    {
                      requestDatas.data.some(item => item.tournament_idx == tournament_idx)
                      ? <Link className="font_style1 btn_play application pop_Modal completion">신청완료</Link>
                      : <Link
                          onClick={() => Insert('/tournament-request', { tournament_idx: tournament_idx }, setDataLoading, () => {
                            Search('/get-tournament-request' , setRequestDatas);
                          })}
                        className="font_style1 btn_play application pop_Modal"
                      >
                        신청하기
                      </Link>
                    }
                  </div>
                }
                {/* ========================================= 플레이 ========================================= */}
                {
                  datas.tournament_state === 'S' && <div className="btns_wrap mt_50 mb_50">
                    <Link className="font_style1 btn_play" onClick={Access}>PLAY <img src={btn_play} alt="btn_play" /></Link>
                  </div>
                }
              </div>

            </div>
          </>
        }
      </div>
    </>
  )
}